import React, { useEffect, useState } from 'react'
import { Space, Modal, Image, Typography } from 'antd'
import { ExclamationCircleOutlined } from '@ant-design/icons'
import Button from 'antd-button-color'
import { toast } from 'react-toastify'
import to from 'await-to-js'
import moment from 'moment'
import TitleBar from '~components/Elements/TitleBar'
// import FormattedMessage from '~components/Elements/FormattedMessage'
import TableWithoutPagination from '~components/Elements/TableWithoutPagination'
import NumberWithCommas from '~utils/NumberWithCommas'
import useFetchTopgraphic from '~hooks/useFetchTopgraphic'
import ServiceAPI from '~services/services'
import AddTopgraphic from '~components/Topgraphic/Add'
import EditTopgraphic from '~components/Topgraphic/Edit'
import ViewTopgraphic from '~components/Topgraphic/View'
import ImageError from '~utils/ImageError'
import { ApplicationState } from '~store/index'
import { useSelector } from 'react-redux'

const Topgraphics = () => {

    const routes = [
        {
            path: '',
            breadcrumbName: 'Topgraphics',
        },
    ];

    const authState = useSelector((state: ApplicationState) => state.auth)
    const permissions = authState.data.permissions
    const { confirm } = Modal;
    const [dataSource, setDataSource] = useState<any>([])
    const [deleteLoading, setDeleteLoading] = useState<boolean>(false)
    const [isAddOpen, setIsAddOpen] = useState<boolean>(false);
    const toggleAdd = () => setIsAddOpen(!isAddOpen)

    const [isEditOpen, setIsEditOpen] = useState(false)
    const toggleEdit = () => setIsEditOpen(!isEditOpen)

    const [isViewOpen, setIsViewOpen] = useState(false)
    const toggleView = () => setIsViewOpen(!isViewOpen)

    const [topgraphicData, setTopgraphicData] = useState<any>()
    const handleEdit = (object: any) => setTopgraphicData(object)

    const { data, mutate, isLoading } = useFetchTopgraphic()

    const handleDelete = (id: string) => {
        confirm({
            title: `You want to delete your Topgraphic?`,
            icon: <ExclamationCircleOutlined />,
            content: `Make sure you want to adjust your Topgraphic`,
            okText: 'Yes',
            cancelText: 'No',
            onOk() {
                (async () => {
                    const [err, res] = await to(ServiceAPI.deleteTopgraphic(id))
                    if (err) {
                        toast.error(err?.message as string)
                        setDeleteLoading(false)
                    } else {
                        mutate()
                        toast.success(res.message)
                        setDeleteLoading(false)
                    }
                })();
            },
            onCancel() {
                setDeleteLoading(false)
            },
        });
    }

    const columns = [
        {
            title: 'Thumbnail',
            dataIndex: 'Thumbnail',
            width: '100px',
            align: 'center',
            render: (text: any, record: any) => (
                <Image
                    className='ant-img-circle'
                    width={32}
                    height={32}
                    alt={record.topic}
                    src={record.thumbnail ? record.thumbnail : 'error'}
                    fallback={ImageError}
                />
            )
        },
        {
            title: 'Background',
            dataIndex: 'Background',
            width: '100px',
            align: 'center',
            render: (text: any, record: any) => (
                <Image
                    className='ant-img-circle'
                    width={32}
                    height={32}
                    alt={record.topic}
                    src={record.background ? record.background : 'error'}
                    fallback={ImageError}
                />

            )
        },
        {
            title: 'Topic',
            dataIndex: 'Topic',
            render: (text: any, record: any) => (
                <div
                    className="text-link"
                    onClick={() => {
                        handleEdit(record)
                        toggleView()
                    }}>
                    <Typography.Text strong>{record.topic}</Typography.Text>
                </div>
            )
        },
        // {
        //     title: 'Description',
        //     dataIndex: 'Description',
        //     render: (text: any, record: any) => (
        //         <div>{(record.Description)}</div>
        //     )
        // },
        {
            title: 'UpdatedAt',
            dataIndex: 'UpdatedAt',
            ellipsis: true,
            width: '140',
            render: (text: any, record: any) => (
                <div className="row-datetime">
                    <div><span>{moment(record.updatedAt).format('DD/MM/YYYY')}</span></div>
                    <div>{moment(record.updatedAt).format('HH:mm:ss')}</div>
                </div>
            )
        },
        {
            title: 'Actions',
            dataIndex: 'action',
            ellipsis: true,
            width: 140,
            align: 'center',
            hidden: permissions && (permissions["TOP-GRAPHICS-MANAGEMENT"] === "VIEW" || permissions["TOP-GRAPHICS-MANAGEMENT"] === "OFF"),
            render: (text: any, record: any) => (
                <Space size={0}>
                    <Button
                        type="warning"
                        size="small"
                        className="me-2"
                        icon={<i className="fa-solid fa-edit me-2"></i>}
                        onClick={() => {
                            handleEdit(record)
                            toggleEdit()
                        }}>
                        Edit
                    </Button>
                    <Button
                        type="danger"
                        size="small"
                        icon={<i className="fa-solid fa-trash me-2"></i>}
                        loading={deleteLoading}
                        onClick={() => {
                            setDeleteLoading(true)
                            handleDelete(record.id)
                        }}>
                        Delete
                    </Button>
                </Space >
            )
        }
    ].filter(item => !item.hidden);

    useEffect(() => {
        setDataSource([])
        if (data !== undefined && data.data.length > 0) {
            setDataSource(data.data)
        }
        return () => {
            setDataSource([])
        }
    }, [data, isLoading, setDataSource])

    return (
        <>
            <TitleBar title="Topgraphics" subTitle={`${NumberWithCommas(dataSource.length || 0)} items`} routes={routes} />
            {permissions && permissions["TOP-GRAPHICS-MANAGEMENT"] === "EDIT" && (
                <div className="row mb-md-3 align-items-md-center">
                    <div className="mb-3 mb-md-0">
                        <Button
                            type="primary"
                            className="d-block ms-auto"
                            icon={<i className="fa-solid fa-plus me-3"></i>}
                            onClick={toggleAdd}>
                            Add Topgraphic
                        </Button>
                    </div>
                </div>
            )}
            <div className="box-white ant-box-table">
                <TableWithoutPagination
                    columns={columns}
                    dataSource={dataSource || []}
                    loading={isLoading}
                    bordered={true}
                />
            </div>
            {isAddOpen && (
                <AddTopgraphic
                    isOpen={isAddOpen}
                    close={toggleAdd}
                    onloadData={mutate}
                />
            )}
            {isEditOpen && (
                <EditTopgraphic
                    isOpen={isEditOpen}
                    close={toggleEdit}
                    onloadData={mutate}
                    data={topgraphicData}
                />
            )}
            {isViewOpen && (
                <ViewTopgraphic
                    isOpen={isViewOpen}
                    close={toggleView}
                    data={topgraphicData}
                    swapDataEdit={() => {
                        toggleView()
                        toggleEdit()
                    }}
                />
            )}
        </>
    )
}

export default Topgraphics